export const redirect = (url) => {
  if (url && window) {
    window.location = url;
  }
};
